export default "__VITE_ASSET__D1LmBD3I__";